import { auth } from "../../config/firebase";

export const signedInUser = !!auth && !!auth.currentUser;
export const unsignedUser = !!auth && !auth.currentUser;